import { apiClient } from '@/shared/lib/apiClient';
import type { ApiResponse, InitiatePaymentResponse, Payment } from '@/types';

const PAYMENT_SESSION_KEY = 'pending_payment_id';

export const paymentApi = {
  async initiate(bookingId: string, returnUrl: string) {
    const response = await apiClient.post<ApiResponse<InitiatePaymentResponse>>(
      `/payments/bookings/${bookingId}/payment`,
      { returnUrl }
    );
    const data = response.data.data!;
    sessionStorage.setItem(PAYMENT_SESSION_KEY, data.payment.id);
    return data;
  },

  async verify(paymentId: string, idempotencyKey?: string, options?: { keepSession?: boolean }) {
    const response = await apiClient.post<ApiResponse<Payment>>(`/payments/${paymentId}/verify`, {
      idempotencyKey,
    });
    const data = response.data.data!;
    if (!options?.keepSession || data.paymentStatus === 'SUCCESS') {
      sessionStorage.removeItem(PAYMENT_SESSION_KEY);
    }
    return data;
  },

  async verifyByOrderId(
    providerOrderId: string,
    idempotencyKey?: string,
    options?: { keepSession?: boolean }
  ) {
    const response = await apiClient.post<ApiResponse<Payment>>('/payments/verify-order', {
      providerOrderId,
      idempotencyKey,
    });
    const data = response.data.data!;
    if (!options?.keepSession || data.paymentStatus === 'SUCCESS') {
      sessionStorage.removeItem(PAYMENT_SESSION_KEY);
    }
    return data;
  },

  /** Remembers a checkout started elsewhere (e.g. extra time) for the return page. */
  rememberPayment(paymentId: string) {
    sessionStorage.setItem(PAYMENT_SESSION_KEY, paymentId);
  },

  getStoredPaymentId(): string | null {
    return sessionStorage.getItem(PAYMENT_SESSION_KEY);
  },
};

export const paymentKeys = {
  all: ['payments'] as const,
  detail: (id: string) => [...paymentKeys.all, id] as const,
};
